// extracted by mini-css-extract-plugin
export default {"conditions":"style_conditions__k0+OJ","condition":"style_condition__P2u+u","name":"style_name__uzH1U"};